import React, { FC, useEffect, useState, Suspense } from 'react';
import superHostKey from 'assets/svg/superhost-user-key-indicator-for-avatar.svg';
import goldCoinIcon from 'assets/images/profile-icons/gold-coin.png';
import silverCoinIcon from 'assets/images/profile-icons/silver-coin.png';
import profileImage from 'assets/images/user.png';
import Styles from 'views/currency/Currency.module.scss';
import Button from 'components/button/Button';
import CustomModal from 'components/customModal/CustomModal';
import RechargeAccountItem from 'components/rechargeAccountItem/RechargeAccountItem';
import SettingsActionButtons from 'components/settingsActionButtons';
import subscriptions from 'helpers/data/subscriptions';
import { getMediaUrl } from 'store/services/URL';
import { Plans } from 'modules/types/types';

const Stripe = React.lazy(() => import('views/Stripe/Stripe'));

interface CurrencyProps {
  cssClass?: string;
  getPlansRequest: Function;
  getPlans: Plans;
}

const Currency: FC<CurrencyProps> = (props: CurrencyProps) => {
  const { cssClass, getPlansRequest, getPlans } = props;
  const [rechargeAccount, setRechargeAccount] = useState(false);
  const [paymentPopUp, setPaymentPopUp] = useState(false);
  const [selected, setSelected] = useState('');
  const [, setPlans] = useState<Plans>();
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  const handleCancel = () => {
    console.log('handle Cancel');
  };

  const handleChanges = () => {
    console.log('handle Changes');
  };

  const closeDialog = () => {
    document.body.classList.remove('modal-open');
    setRechargeAccount(false);
  };

  const rechargeAccountModal = () => (
    <>
      <div className={Styles.rechargeCard}>
        {subscriptions.map((item, key) => (
          <RechargeAccountItem item={item} selected={selected} handleSelect={setSelected} key={key} />
        ))}
      </div>
      <div className="text-center">
        <Button
          label="PROCEED TO PAYMENT MERCHANT"
          disabled={selected === ''}
          cssClass="mt-5 mb-3"
          clickHandler={handlePaymentMerchant}
        />
        <div
          className="fontFourteen text-blue font-weight-bold text-uppercase"
          onClick={() => closeDialog()}
          onKeyPress={() => closeDialog()}
          role="button"
          tabIndex={0}
        >
          Close
        </div>
      </div>
    </>
  );

  const stripePaymentModal = () => (
    <Suspense fallback={<div>Loading...</div>}>
      <Stripe type="recharge" planId={selected} closeDialog={setPaymentPopUp} />
    </Suspense>
  );

  const handlePaymentMerchant = () => {
    setRechargeAccount(false);
    setPaymentPopUp(true);
  };

  useEffect(() => {
    getPlansRequest({});
  }, []);

  useEffect(() => {
    setPlans(getPlans);
  }, [getPlans]);

  const goldCount = user?.gold_coin ?? '0';
  const silverCount = user?.silver_coin ?? '0';
  const goldLabel = `${goldCount} Gold ${Number(goldCount) === 1 ? 'Piece' : 'Pieces'}`;
  const silverLabel = `${silverCount} Silver ${Number(silverCount) === 1 ? 'Piece' : 'Pieces'}`;

  return (
    <div className={Styles.currencyContent}>
      <div className={Styles.currencyCard}>
        <div className={`${Styles.avatarWrapper} ${cssClass || ''}`}>
          <img
            src={getMediaUrl(user?.profile) || profileImage}
            alt="profile"
            className={Styles.avatarImage}
          />
          {user?.is_super_host && (
            <img src={superHostKey} alt="super host" className={Styles.superHostBadge} />
          )}
        </div>

        <h2 className={Styles.userName}>{user?.name}</h2>
        {user?.is_super_host ? (
          <p className={Styles.superHostLabel}>SUPER HOST</p>
        ) : (
          <div className={Styles.roleSpacer} />
        )}

        <h3 className={Styles.balanceHeading}>ACCOUNT BALANCE</h3>

        <div className={Styles.balanceRow}>
          <div className={Styles.balanceCard}>
            <span className={Styles.balanceText}>{goldLabel}</span>
            <img src={goldCoinIcon} className={Styles.coinIcon} alt="gold coin" />
          </div>
          <div className={Styles.balanceCard}>
            <span className={Styles.balanceText}>{silverLabel}</span>
            <img src={silverCoinIcon} className={Styles.coinIcon} alt="silver coin" />
          </div>
        </div>

        <button
          className={Styles.rechargeLink}
          onClick={() => setRechargeAccount(true)}
          type="button"
        >
          + RECHARGE ACCOUNT
        </button>
      </div>

      <SettingsActionButtons onCancel={handleCancel} onSave={handleChanges} />

      {rechargeAccount && (
        <CustomModal closeDialog={closeDialog} title="Recharge Account" wrapperClass={Styles.rechargeAccountWrapper}>
          {rechargeAccountModal()}
        </CustomModal>
      )}
      {paymentPopUp && (
        <CustomModal closeDialog={closeDialog} title="Recharge Account" wrapperClass={Styles.rechargeAccountWrapper}>
          {stripePaymentModal()}
        </CustomModal>
      )}
    </div>
  );
};

export default Currency;
